// store.js
import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios'; // Ensure you have axios installed

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isAuthenticated: false,
    accountData: [],  // New state for the account data
    isLoading: false,
    loginError: null,
  },
  
  mutations: {
    SET_LOADING(state, payload) {
      state.isLoading = payload;
    },
    authenticate(state) {
      state.isAuthenticated = true;
    },
    logout(state) {
      state.isAuthenticated = false;
    },
    SET_ACCOUNT_DATA(state, data) {
      // Handle the initial data
      state.accountData = data;
    },
    SET_ADDITIONAL_ACCOUNT_DATA(state, additionalData) {
      // Check if state.accountData is an array
      if (Array.isArray(state.accountData)) {
        // If it's an array, merge additionalData into each item in the array
        state.accountData = state.accountData.map(item => ({
          ...item,
          ...additionalData
        }));
      } else {
        // If it's an object, merge additionalData into the object
        state.accountData = {
          ...state.accountData,
          ...additionalData
        };
      }
    },
    SET_ERROR(state, errorMessage) {
      state.loginError = errorMessage;
    }
  },

  actions: {
    async login({ commit }, credentials) {
      commit("SET_LOADING", true);
      //console.log('credentials', credentials);
      try {
        // Make a POST request to the custom login endpoint
        const response = await axios.post(
          //`${process.env.API_GATEWAY_URL}/wp-json/custom/v1/validate-password`,
          "https://engagr.driveagent.io/wp-json/custom/v1/validate-password",
          credentials
        );
  
        // If response is successful
        if (response.data && response.status === 200) {
          //console.log('response', response.data);
          // commit authentication and user data mutations
          commit("authenticate");
          commit('SET_ADDITIONAL_ACCOUNT_DATA', response.data);
          commit("authenticate", true);
        }
      } catch (error) {
        // Handle error
        //console.error(error);
        commit("SET_ERROR", "Invalid credentials or another error occurred."); // Add this

      } finally {
        commit("SET_LOADING", false);
      }
    },
    async fetchAccountData({ commit }, slug) {
      commit('SET_LOADING', true); // set loading to true when the fetch starts
    
      try {
        const initialEndpoint = `https://engagrcdn.b-cdn.net/account/${slug}.json`;
        const response = await axios.get(initialEndpoint);
        commit('SET_ACCOUNT_DATA', response.data);
  
        // Check if Protected is true and return an error if it is.
        // if (response.data.Protected || (response.data[0] && response.data[0].Protected)) {
        //   commit("authenticate", false);
        //   return 'protected';
        // }
  
        // Continue processing if Protected is not true
        if (response.data[0] && response.data[0].id && !response.data[0].Protected) {
          const additionalEndpoint = `https://engagr.driveagent.io/wp-json/account/v1/get/${response.data[0].id}`;
          const additionalResponse = await axios.get(additionalEndpoint);
          
          if (additionalResponse) {
            commit('SET_ADDITIONAL_ACCOUNT_DATA', additionalResponse.data);
            commit("authenticate", true);
          }
        }
      } catch (error) {
        console.error("Error fetching account data:", error);
      } finally {
        commit('SET_LOADING', false); // set loading to false when the fetch ends
      }
    }
    
  }
  
  
});
